import React, { FC } from "react";
import { Button, List, Tooltip } from "antd";
import { Icons } from "../vpd-icons/icons";
import { Notification, NotificationType } from "../../data-types";
import styles from "./notification-row.module.css";
import { MessageOutlined, PartitionOutlined, BellOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

type Props = {
  notification: Notification;
  onViewMatter: (id: number, isParent: boolean) => void;
  onDelete: (id: number) => void;
  onViewMessage: (id: number) => void;
};

const {
  meta: metaClassName,
  title: titleClassName,
  alert_title: alertTitleClassName,
  description: descriptionClassName,
} = styles;

export const NotificationRow: FC<Props> = ({
  notification: { id, title, description, message, type, isParent },
  onDelete,
  onViewMatter,
  onViewMessage,
}) => (
  <List.Item
    key={id}
    actions={[
      <Button
        key={`view-${id}`}
        shape="circle"
        onClick={() => {
          onViewMatter(id, isParent);
        }}
        type="link"
      >
        View Matter
      </Button>,
      <Button
        key={`message-${id}`}
        disabled={!message}
        icon={<MessageOutlined />}
        shape="circle"
        onClick={() => {
          onViewMessage(id);
        }}
        type="link"
      />,
      <Button
        key={`delete-${id}`}
        icon={Icons.Delete}
        shape="circle"
        onClick={() => {
          onDelete(id);
        }}
        type="link"
      />,
    ]}
  >
    <List.Item.Meta
      avatar={
        type === NotificationType.Alert ? (
          <ExclamationCircleOutlined
            style={{
              fontSize: "20px",
              color: "var(--error-color)",
            }}
          />
        ) : (
          <BellOutlined
            style={{
              fontSize: "20px",
              color: "var(--primary-color)",
            }}
          />
        )
      }
      title={
        <span className={type === NotificationType.Alert ? alertTitleClassName : titleClassName}>
          {title}
          {isParent && (
            <Tooltip title={`This is a multi discipline proposal`} placement="bottomRight">
              {<PartitionOutlined style={{ marginLeft: 5 }} />}
            </Tooltip>
          )}
        </span>
      }
      description={<span className={descriptionClassName}>{description}</span>}
      className={metaClassName}
    />
  </List.Item>
);
